// @mui material components
import {
  Snackbar,
  Alert,
  Grid,
  Card,
  CircularProgress,
  Backdrop,
  Icon,
  Dialog,
  //   DialogTitle,
  //   DialogContent,
  DialogActions,
  Divider,
} from "@mui/material";

// Material Dashboard 2 React components
import MDBox from "theme/components/MDBox";
import MDTypography from "theme/components/MDTypography";
import MDButton from "theme/components/MDButton";
// import MDInput from "theme/components/MDInput";

// Material Dashboard 2 React example components
import DashboardLayout from "app/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/Navbars/DashboardNavbar";
import Footer from "theme/Footer";

import { useEffect, useState } from "react";
import axios from "axios.js";
import DataTable from "theme/Tables/DataTable";
import usePageTitle from "app/pageTitle";
import AppConfig from "appConfig";

// import { toPng } from "html-to-image";
import QRCode from "react-qr-code";
import { Watermark } from "@hirohe/react-watermark";

function CourseCertificates() {
  const pageTitle = "Trainings Certificates";
  usePageTitle(pageTitle);

  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
  };

  const [certificates, setCertificates] = useState([]);
  const [selectedCertificate, setSelectedCertificate] = useState(null);
  const [openCertificateDialog, setOpenCertificateDialog] = useState(false);

  const tableColumns = [
    { Header: "Course", accessor: "course", align: "left" },
    { Header: "Certificate", accessor: "action", align: "right" },
  ];

  const buildRows = (data) => {
    const rows = [];
    data.map((row) => {
      rows.push({
        action: (
          <MDButton
            size="medium"
            variant="outlined"
            color="warning"
            iconOnly
            circular
            onClick={() => {
              setSelectedCertificate(row);
              setOpenCertificateDialog(true);
            }}
          >
            <Icon sx={{ cursor: "pointer" }} fontSize="small" color="dark">
              workspace_premium
            </Icon>
          </MDButton>
        ),
        course: row.course,
      });
      return null;
    });

    return rows;
  };

  useEffect(() => {
    const fetchData = async () => {
      setShowLoading(true);
      await axios
        .get("agents/trainings/certificates.json")
        .then((result) => {
          // console.log(result);
          setShowLoading(false);
          if (result.data.status === "success") {
            const rows = buildRows(result.data.data.certificates);
            setCertificates(rows);
          } else {
            setSeverity("error");
            setErrMsg(result.data.data.message);
            setOpen(true);
          }
        })
        .catch(() => {
          setShowLoading(false);
          setSeverity("error");
          setErrMsg(
            `Unable to complete request. ${
              navigator.onLine ? "" : "Make sure you have an active internet connection"
            }`
          );
          setOpen(true);
        });
    };

    fetchData();
  }, []);

  function downloadCertificate(downloadUrl) {
    // toPng(document.getElementById(`${selectedCertificate.reference}`), { quality: 0.95 })
    //   .then((dataUrl) => {
    //     const link = document.createElement("a");
    //     link.href = dataUrl;
    //     link.download = `${selectedCertificate.course} certificate.png`;
    //     link.click();
    //   })
    //   .catch((error) => {
    //     console.error("Error generating certificate:", error);
    //   });
    window.open(downloadUrl, "_blank");
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
          {errorMsg}
        </Alert>
      </Snackbar>

      {selectedCertificate ? (
        <Dialog open={openCertificateDialog} fullWidth maxWidth="md">
          <MDBox
            m={3}
            p={3}
            sx={{ borderRadius: "10px", border: "0.5px solid #333333" }}
            align="center"
            id={selectedCertificate.reference}
          >
            <Watermark text="*laddar africa*" textSize={36}>
              <MDBox>
                <MDBox mb={3}>
                  <img src={`${AppConfig.api_media_url}logos/laddar_logo.png`} alt="" width="25%" />
                </MDBox>
                <MDBox fontWeight="bold">CERTIFICATE OF COMPLETION</MDBox>
              </MDBox>
              <MDBox mt={3}>
                <MDTypography fontWeight="light" fontSize="small">
                  This certifies that
                </MDTypography>
              </MDBox>
              <MDBox mt={3}>
                <MDTypography variant="h6" fontWeight="bold" fontSize="large">
                  {selectedCertificate.name}
                </MDTypography>
              </MDBox>
              <MDBox mt={3}>
                <MDTypography fontWeight="light" fontSize="small" mt={3}>
                  has completed the course entitled below with flying colors.
                </MDTypography>
              </MDBox>
              <MDBox mt={3}>
                <MDTypography variant="h6" fontWeight="bold" fontSize="large">
                  {selectedCertificate.course}
                </MDTypography>
              </MDBox>
              <MDBox mt={3}>
                <Divider />
              </MDBox>
              <MDBox mt={5}>
                <MDTypography variant="h6" fontWeight="light" fontSize="small">
                  Issued
                  <br />
                  <b>{selectedCertificate.created}</b>
                </MDTypography>
              </MDBox>
              <MDBox mt={3}>
                <Grid container spacing={3}>
                  <Grid item xs={12} md={6} lg={6}>
                    <MDBox mt={5}>
                      <MDTypography variant="h6" fontWeight="light" fontSize="small">
                        <small>
                          Certified by Laddar Africa. <br />
                          <strong>https://laddar.africa</strong>
                        </small>
                      </MDTypography>
                    </MDBox>
                  </Grid>
                  <Grid item xs={12} md={6} lg={6}>
                    <MDBox mt={5}>
                      <QRCode value={selectedCertificate.link} size={48} />
                    </MDBox>
                  </Grid>
                </Grid>
              </MDBox>
              <MDBox mt={2}>
                <MDTypography variant="h6" fontWeight="light" fontSize="small">
                  {selectedCertificate.link}
                </MDTypography>
              </MDBox>
            </Watermark>
          </MDBox>

          <DialogActions>
            <MDButton
              onClick={() => {
                setOpenCertificateDialog(false);
              }}
              color="dark"
              variant="outlined"
              iconOnly
              circular
            >
              <Icon sx={{ cursor: "pointer" }} fontSize="small" color="dark">
                close
              </Icon>
            </MDButton>
            <MDButton
              onClick={() => downloadCertificate(selectedCertificate.links.download)}
              color="warning"
              variant="outlined"
              iconOnly
              circular
            >
              <Icon sx={{ cursor: "pointer" }} fontSize="small" color="dark">
                download
              </Icon>
            </MDButton>
          </DialogActions>
        </Dialog>
      ) : (
        <> </>
      )}

      <MDBox pt={3} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Grid container spacing={3}>
              <Grid item xs={12} md={12} lg={12}>
                <MDBox>
                  <Card sx={{ height: "100%", marginTop: "0px" }}>
                    <MDBox p={3}>
                      <MDBox>
                        <MDTypography variant="h6" fontWeight="medium">
                          <Icon>school</Icon> Trainings Certificates
                        </MDTypography>
                        <MDTypography variant="h6" fontWeight="light" mt={2}>
                          My certificates
                        </MDTypography>
                      </MDBox>
                    </MDBox>
                  </Card>
                </MDBox>
                <MDBox mt={5}>
                  <Card sx={{ height: "100%", marginTop: "0px" }}>
                    <MDBox p={3}>
                      <MDBox ml={1} mr={3}>
                        <Grid container spacing={3}>
                          <Grid item xs={6} md={6} lg={6}>
                            <MDTypography variant="h6" fontWeight="medium">
                              <Icon>local_library</Icon> Courses
                            </MDTypography>
                          </Grid>
                        </Grid>
                      </MDBox>
                      <MDBox mt={3}>
                        <DataTable
                          table={{ columns: tableColumns, rows: certificates }}
                          isSorted
                          entriesPerPage={false}
                          showTotalEntries
                          noEndBorder
                          canSearch={false}
                        />
                      </MDBox>
                    </MDBox>
                  </Card>
                </MDBox>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default CourseCertificates;
